let cloneMenu = () => {
    let pcMenu = document.querySelector('#mainMenu .menuBox')
    let mobileMenu = document.querySelector('#mainMenuTable')
    let cloneMenu = $(pcMenu).clone()
    $(cloneMenu).removeClass('nano-content')
    $(cloneMenu).find('img.menu-img-gif').remove()
    $(mobileMenu).find('.top_bar_addToAny').before(cloneMenu)
}

let animateVelocity = () => {

    $(window).on('G2_onLeave', () => {
        $('.trailer-videos-item,.trailer-title').velocity('finish').velocity({opacity: 0}, {display: 80})
        $('.trailer-content>.row').removeClass('overflowY')
    })

    $(window).on('G2_afterLoad', (ev) => {
        if (ev.index === 3) {
            $('.trailer-videos-item').velocity('transition.slideUpBigIn', {
                delay: 100,
                stagger: 80,
            })
            $('.trailer-title,.trailer-content').velocity('transition.slideUpBigIn', {
                complete: function () {
                    setTimeout(() => {
                        $('.trailer-content>.row').addClass('overflowY')
                    }, 1000)
                }
            })
        }
    })

}

export {cloneMenu, animateVelocity}